const body = document.querySelector('body');
const observerOptions = {
    attributes: true,
    childList: true,
    subtree: true,
};

const bodyCallback = (mutationList, observer) => {
    const sparkDrawer = body.querySelector('spark-drawer') ? body.querySelector('spark-drawer').shadowRoot : null;
    const sparkDrawerCallBack = () => {
        // console.log('accountSparkCallBack ... CHANGE');
        const accountSpark = sparkDrawer.querySelector('spark-my-customers:not(.hide)')
            ? sparkDrawer.querySelector('spark-my-customers').shadowRoot
            : null;

        const accountSparkCallBack = () => {
            const listItems = accountSpark.querySelector('.search-agent__wrapper .list-items');
            if (listItems) {
                const allItems = Array.from(listItems.querySelectorAll('.list-items-wrap.item-default'));
                for (const item of allItems) {
                    const itemEmail = item.querySelector('.item-summary .account-default')
                        ? item.querySelector('.item-summary .account-default').innerText.toLowerCase()
                        : null;
                    const selectedBrand = localStorage.getItem('selectedBrand');
                    if (itemEmail && selectedBrand) {
                        const notBrand = selectedBrand == 'cosmetics' ? 'nails' : 'cosmetics';
                        if (itemEmail.includes(`${notBrand}_`)) {
                            item.remove();
                        }
                    }
                }
            }
            const addressesListParent = accountSpark.querySelector('.section.account-item:last-child');
            if (addressesListParent) {
                const buttonAdd = addressesListParent.querySelector('.title-with-link button');
                if (buttonAdd) {
                    buttonAdd.remove();
                }
                const addressesList = addressesListParent.querySelectorAll('.list-items-wrap')
                    ? Array.from(addressesListParent.querySelectorAll('.list-items-wrap'))
                    : [];
                for (const address of addressesList) {
                    const buttons = address.querySelector('.action-buttons');
                    if (buttons) {
                        buttons.remove();
                    }
                }
            }
        };

        const accountSparkObserver = new MutationObserver(accountSparkCallBack);
        if (accountSpark) {
            accountSparkObserver.observe(accountSpark, observerOptions);
        } else {
            console.log('disconnect');
            accountSparkObserver.disconnect();
        }
    };

    const sparkDrawerObserver = new MutationObserver(sparkDrawerCallBack);
    if (sparkDrawer) {
        sparkDrawerObserver.observe(sparkDrawer, observerOptions);
    } else {
        sparkDrawerObserver.disconnect();
    }
};

const bodyObserver = new MutationObserver(bodyCallback);
bodyObserver.observe(body, observerOptions);
